/**
 * Mobile Menu Module
 * Handles mobile menu toggle functionality
 */

export default function initMobileMenu() {
    const menuToggle = document.querySelector('.wp-block-navigation__responsive-container-open');
    const closeMenuButton = document.querySelector('.wp-block-navigation__responsive-container-close');
    
    if (menuToggle) {
        menuToggle.addEventListener('click', function() {
            document.body.classList.add('mobile-menu-open');
        });
    }
    
    if (closeMenuButton) {
        closeMenuButton.addEventListener('click', function() {
            document.body.classList.remove('mobile-menu-open');
        });
    }
}

